module.exports = __webpack_public_path__ + "static/media/feb.e2b06f52.jpg";